type DiscordJoinToastProps = {
  href: string;
};

export function DiscordJoinToast({ href }: DiscordJoinToastProps) {
  return (
    <div
      className="landing-sans-copy pointer-events-none fixed inset-x-0 bottom-0 z-[100] flex justify-center px-4 pb-[max(1rem,env(safe-area-inset-bottom))] pt-2"
      role="region"
      aria-label="Community invite"
    >
      <div className="pointer-events-auto discord-toast-enter relative flex max-w-md flex-1 items-center gap-3 rounded-[22px] border border-white/22 bg-white/[0.08] px-4 py-3 shadow-[0_12px_40px_rgba(0,0,0,0.45),0_0_0_1px_rgba(255,255,255,0.06)_inset,0_1px_0_rgba(255,255,255,0.35)_inset] backdrop-blur-2xl backdrop-saturate-[1.8] [-webkit-backdrop-filter:blur(24px)_saturate(1.8)]">
        <div
          className="pointer-events-none absolute inset-0 rounded-[22px] opacity-90"
          style={{
            background:
              "linear-gradient(145deg, rgba(255,255,255,0.22) 0%, rgba(255,255,255,0.04) 42%, rgba(255,255,255,0.08) 100%)",
          }}
          aria-hidden
        />
        <div className="relative z-[1] flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-[#5865F2] shadow-[inset_0_1px_0_rgba(255,255,255,0.25)] ring-1 ring-white/25">
          <img
            src="/discord-mark.svg"
            alt=""
            width={26}
            height={20}
            className="h-5 w-[26px] object-contain"
            decoding="async"
          />
        </div>
        <div className="relative z-[1] min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2">
            <p className="text-[15px] font-semibold leading-tight tracking-tight text-white">
              Join the Discord
            </p>
            <span className="inline-flex items-center rounded-md bg-[#FF3B30] px-2 py-0.5 text-[10px] font-bold uppercase leading-none tracking-wide text-white shadow-[0_2px_8px_rgba(255,59,48,0.45),inset_0_1px_0_rgba(255,255,255,0.35)] ring-1 ring-white/25">
              New — join in!
            </span>
          </div>
          <p className="mt-0.5 text-[13px] leading-snug text-white/72">
            Updates, prompts, and the community — tap to hop in.
          </p>
        </div>
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="relative z-[1] shrink-0 self-center rounded-full bg-white/95 px-3.5 py-1.5 text-[13px] font-semibold text-[#1d1d1f] shadow-[0_2px_12px_rgba(0,0,0,0.12)] ring-1 ring-black/5 transition hover:bg-white"
        >
          Open
        </a>
      </div>
    </div>
  );
}
